import { render, staticRenderFns } from "./MaterialCost.vue?vue&type=template&id=57b2304b"
import script from "./MaterialCost.vue?vue&type=script&lang=ts"
export * from "./MaterialCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports